<template>
    <span class="inline-flex items-center" :class="cssClass">
        <span :class="{'text-primary-80': item.price < item.list_price}">
            <currency/>
        </span>
        <template v-if="item.price < item.list_price">
            <span class="text-primary-80 line-through -mb-2">
                {{ formatPrice(item.list_price) }}
            </span>
            <span class="text-secondary font-semibold ml-4 -mb-2">
                {{ formatPrice(item.price) }}
            </span>
        </template>
        <span v-else>
            <span class="-mb-2">{{ formatPrice(item.price) }}</span>
        </span>
    </span>
</template>

<script>
import Currency from './Currency.vue';

export default {
    components: { Currency },
    props: {
        item: {
            type: Object,
            required: true
        },
        cssClass: {
            type: String,
            default: ''
        }
    },
    methods: {
        formatPrice(price) {
            if (!price) return price;

            return price.toFixed(2).replace('.', ',');
        },
    }
}
</script>

<style scoped>

</style>
